import { ArrowsClockwiseIcon } from "@phosphor-icons/react";

import { clsx } from "@alpacahq/ui/old";

interface QuoteDataProps {
  bidDisplay: string;
  lastDisplay: string;
  askDisplay: string;
  valueSize: string;
  lastUpdated: string;
  onRefreshQuoteClicked: () => void;
}

export const QuoteData = ({
  bidDisplay,
  lastDisplay,
  askDisplay,
  valueSize,
  lastUpdated,
  onRefreshQuoteClicked,
}: QuoteDataProps) => (
  <div className="flex flex-col gap-2 py-2">
    <div className="flex justify-between gap-0.5">
      <div className="flex min-w-0 flex-col items-start justify-start gap-0.5">
        <p className="m-0 p-0 text-[10px] text-gray-700 leading-[14px]">Bid</p>
        <p
          className={clsx(
            "m-0 break-all p-0 font-mono text-emerald-600",
            valueSize,
          )}
        >
          {bidDisplay}
        </p>
      </div>
      <div className="mt-3 h-[22px] w-px shrink-0 bg-gray-300" />
      <div className="flex min-w-0 flex-col items-center justify-center gap-0.5">
        <p className="m-0 p-0 text-[10px] text-gray-700 leading-[14px]">Last</p>
        <p
          className={clsx(
            "m-0 break-all p-0 font-medium font-mono text-gray-800",
            valueSize,
          )}
        >
          {lastDisplay}
        </p>
      </div>
      <div className="mt-3 h-[22px] w-px shrink-0 bg-gray-300" />
      <div className="flex min-w-0 flex-col items-end justify-start gap-0.5">
        <p className="m-0 p-0 text-[10px] text-gray-700 leading-[14px]">Ask</p>
        <p
          className={clsx(
            "m-0 break-all p-0 font-mono text-red-500",
            valueSize,
          )}
        >
          {askDisplay}
        </p>
      </div>
    </div>
    <div className="flex items-center justify-end gap-1">
      <p className="m-0 p-0 font-mono text-gray-500 text-xs">{lastUpdated}</p>
      <button
        aria-label="Refresh quote"
        onClick={onRefreshQuoteClicked}
        type="button"
      >
        <ArrowsClockwiseIcon
          size={16}
          className="text-indigo-600 hover:text-indigo-500 active:text-indigo-400"
        />
      </button>
    </div>
  </div>
);
